import { UPDATE_COLUMN_TEXT_INPUT, UPDATE_TEXT_INPUT } from '../actions';
const initialState = {
    textInput: '',
    smsOrEmail: '',
};
export function DialogReducer(state = initialState, action) {
    switch (action.type) {
        case UPDATE_TEXT_INPUT:
            return Object.assign(Object.assign({}, state), action.payload);
        case UPDATE_COLUMN_TEXT_INPUT:
            return Object.assign(Object.assign({}, state), { smsOrEmail: action.payload.smsOrEmail || '' });
        default:
            return state;
    }
}
